import React from 'react';
import ReactDOM from 'react-dom';
import configureStore from './redux/store';
import Root from './Root';
import AbacusClientUtils from '@homeaway/abacus-client-utils';

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */
const initialState = window.__INITIAL_STATE__;

if (!module.hot) {
  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = window.__webpack_public_path__;
}

const store = configureStore(initialState);

const abacusExperiments = store.getState().abacus.experiments;
AbacusClientUtils.initialize(abacusExperiments);

ReactDOM.hydrate(<Root store={store}/>, document.getElementById('root'));